<template>
  <div>
    <page-title title="Page Not Found" />
    <p>The page you're looking for could not be found.</p>
  </div>
</template>

<script>

export default {
  name: 'NotFound',
  props: {},
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
    load: function () {
    }
  },
  mounted () {
    this.load();
    // Use this instead of the previous line to test the "Loading" bar
    //window.setTimeout(this.load, 3000);
  }
}
</script>